// extracted by mini-css-extract-plugin
module.exports = {"main":"Helpdesk_main__Ki7am"};